/**
 * EE Wishlist — localStorage-backed wishlist with drawer + page rendering.
 * Storage model mirrors the live theme: { variantId: productHandle }.
 */
(function () {
  'use strict';

  var drawerEl = null;

  function storageKey() {
    var cid = window.eeWishlistCustomerId;
    return 'ee-wishlist-' + (cid ? 'customer-' + cid : 'guest');
  }

  function rootUrl() {
    var d = document.querySelector('wishlist-drawer');
    return (d && d.dataset.rootUrl) || '/';
  }

  function read() {
    try {
      return JSON.parse(localStorage.getItem(storageKey())) || {};
    } catch (e) {
      return {};
    }
  }

  function write(map) {
    try {
      localStorage.setItem(storageKey(), JSON.stringify(map));
    } catch (e) {}
    syncCount();
    syncToggles();
    renderDrawer();
    renderPage();
  }

  function items() {
    var map = read();
    return Object.keys(map).map(function (vid) {
      return { variantId: vid, handle: map[vid] };
    });
  }

  function has(variantId) {
    return Object.prototype.hasOwnProperty.call(read(), String(variantId));
  }

  function toggle(variantId, handle) {
    var map = read();
    var id = String(variantId);
    var added;
    if (map[id]) {
      delete map[id];
      added = false;
    } else {
      map[id] = handle;
      added = true;
    }
    write(map);
    return added;
  }

  function remove(variantId) {
    var map = read();
    delete map[String(variantId)];
    write(map);
  }

  function syncCount() {
    var n = items().length;
    document.querySelectorAll('[data-ee-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncToggles() {
    document.querySelectorAll('[data-ee-wishlist-toggle]').forEach(function (btn) {
      var added = has(btn.dataset.variantId);
      btn.classList.toggle('is-added', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      var label = btn.querySelector('[data-ee-wishlist-label]');
      if (label) {
        label.textContent = added
          ? btn.dataset.addedText || 'Added'
          : btn.dataset.addText || 'Add to wishlist';
      }
    });
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function fetchProduct(handle) {
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function productUrl(handle, variantId) {
    return rootUrl() + 'products/' + handle + '?variant=' + variantId;
  }

  function getDrawer() {
    if (!drawerEl) drawerEl = document.querySelector('wishlist-drawer');
    return drawerEl;
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) {
      window.location.href = rootUrl() + 'pages/wishlist';
      return;
    }
    d.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.removeAttribute('open');
    document.body.style.overflow = '';
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function itemRow(entry, product) {
    var variant = null;
    if (product) {
      variant =
        product.variants.find(function (v) {
          return String(v.id) === String(entry.variantId);
        }) || product.variants[0];
    }

    var row = el('div', 'ee-wishlist-item');
    row.dataset.variantId = entry.variantId;

    var imgLink = el('a', 'ee-wishlist-item__image');
    imgLink.href = product ? productUrl(entry.handle, entry.variantId) : '#';
    if (product && product.featured_image) {
      var img = document.createElement('img');
      img.src = product.featured_image.replace(/(\.[^.]*)$/, '_150x$1');
      img.alt = product.title;
      img.loading = 'lazy';
      img.width = 75;
      img.height = 75;
      imgLink.appendChild(img);
    }
    row.appendChild(imgLink);

    var details = el('div', 'ee-wishlist-item__details');
    var name = el('a', 'ee-wishlist-item__name', product ? product.title : entry.handle);
    name.href = product ? productUrl(entry.handle, entry.variantId) : '#';
    details.appendChild(name);
    if (variant && variant.title && variant.title !== 'Default Title') {
      details.appendChild(el('div', 'ee-wishlist-item__variant', variant.title));
    }
    if (variant) {
      details.appendChild(el('div', 'ee-wishlist-item__price', money(variant.price)));
    }
    row.appendChild(details);

    var removeBtn = el('button', 'ee-wishlist-item__remove');
    removeBtn.type = 'button';
    removeBtn.dataset.eeWishlistRemove = '';
    removeBtn.dataset.variantId = entry.variantId;
    removeBtn.setAttribute('aria-label', 'Remove ' + (product ? product.title : 'item'));
    removeBtn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
    row.appendChild(removeBtn);

    return row;
  }

  function renderDrawer() {
    var d = getDrawer();
    if (!d) return;
    var listEl = d.querySelector('[data-ee-wishlist-items]');
    var emptyEl = d.querySelector('[data-ee-wishlist-empty]');
    var footEl = d.querySelector('[data-ee-wishlist-foot]');
    if (!listEl) return;

    var entries = items();
    if (!entries.length) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    Promise.all(entries.map(function (e) { return fetchProduct(e.handle); })).then(
      function (products) {
        // Re-check: wishlist may have changed while fetching
        var current = items();
        listEl.innerHTML = '';
        current.forEach(function (entry, i) {
          var idx = entries.findIndex(function (e) {
            return String(e.variantId) === String(entry.variantId);
          });
          listEl.appendChild(itemRow(entry, idx > -1 ? products[idx] : null));
        });
        if (footEl) footEl.hidden = false;
      }
    );
  }

  function renderPage() {
    var pageEl = document.querySelector('[data-ee-wishlist-page]');
    if (!pageEl) return;
    var grid = pageEl.querySelector('[data-ee-wishlist-grid]');
    var emptyEl = pageEl.querySelector('[data-ee-wishlist-page-empty]');
    if (!grid) return;

    var entries = items();
    if (!entries.length) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    Promise.all(entries.map(function (e) { return fetchProduct(e.handle); })).then(
      function (products) {
        var current = items();
        grid.innerHTML = '';
        current.forEach(function (entry) {
          var idx = entries.findIndex(function (e) {
            return String(e.variantId) === String(entry.variantId);
          });
          var product = idx > -1 ? products[idx] : null;
          var variant = null;
          if (product) {
            variant =
              product.variants.find(function (v) {
                return String(v.id) === String(entry.variantId);
              }) || product.variants[0];
          }

          var card = el('div', 'ee-wishlist-card');
          var link = el('a', 'ee-wishlist-card__media');
          link.href = product ? productUrl(entry.handle, entry.variantId) : '#';
          if (product && product.featured_image) {
            var img = document.createElement('img');
            img.src = product.featured_image.replace(/(\.[^.]*)$/, '_480x$1');
            img.alt = product.title;
            img.loading = 'lazy';
            link.appendChild(img);
          }
          card.appendChild(link);

          var body = el('div', 'ee-wishlist-card__body');
          var title = el('a', 'ee-wishlist-card__title', product ? product.title : entry.handle);
          title.href = link.href;
          body.appendChild(title);
          if (variant && variant.title && variant.title !== 'Default Title') {
            body.appendChild(el('div', 'ee-wishlist-card__variant', variant.title));
          }
          if (variant) {
            body.appendChild(el('div', 'ee-wishlist-card__price', money(variant.price)));
          }
          var actions = el('div', 'ee-wishlist-card__actions');
          var view = el('a', 'ee-wishlist-card__view button button--primary', pageEl.dataset.viewLabel || 'View product');
          view.href = link.href;
          actions.appendChild(view);
          var rm = el('button', 'ee-wishlist-card__remove', pageEl.dataset.removeLabel || 'Remove');
          rm.type = 'button';
          rm.dataset.eeWishlistRemove = '';
          rm.dataset.variantId = entry.variantId;
          actions.appendChild(rm);
          body.appendChild(actions);
          card.appendChild(body);
          grid.appendChild(card);
        });
      }
    );
  }

  // Event delegation
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-ee-wishlist-toggle]'))) {
      e.preventDefault();
      var added = toggle(t.dataset.variantId, t.dataset.handle);
      if (added) openDrawer();
    } else if ((t = e.target.closest('[data-ee-wishlist-open]'))) {
      e.preventDefault();
      openDrawer();
    } else if (e.target.closest('[data-ee-wishlist-close]')) {
      closeDrawer();
    } else if ((t = e.target.closest('[data-ee-wishlist-remove]'))) {
      remove(t.dataset.variantId);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function init() {
    syncCount();
    syncToggles();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API (used by section JS, e.g. variant switching)
  window.eeWishlist = {
    items: items,
    has: has,
    toggle: toggle,
    remove: remove,
    open: openDrawer,
    close: closeDrawer,
    syncToggles: syncToggles,
    syncCount: syncCount
  };
})();
